import {
  Module,
  VuexModule,
  Mutation,
  Action,
  MutationAction,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  LOGIN,
  M_POST,
  FIND_SUBPASS,
  CREATE_SUBPASS,
  VER_SUBPASS,
  REFRESH_TOKEN,
  AMBSLOT_SECRET,
  PUBLIC_KEY_HEADER,
} from '@/utils/api';

import serviceUtils from '@/services/utils';
import NodeRSA from 'node-rsa';

import Vue from 'vue';

const RSA = new NodeRSA(PUBLIC_KEY_HEADER);

@Module({ name: 'auth' })
export default class Auth extends VuexModule {
  token: string = serviceUtils.getUserPersistent().token || '';

  tokenRefresh: string = serviceUtils.getUserPersistent().tokenRefresh || '';

  balance: number = serviceUtils.getUserBalance() || 0;

  user = serviceUtils.getUserPersistent().user || {};

  @Mutation
  mutateLogin(data: any) {
    const {
      token,
      tokenRefresh,
      balance,
      user,
    } = data;
    this.token = token;
    this.tokenRefresh = tokenRefresh;
    this.balance = balance;
    this.user = user;
  }

  @Action
  Login(userdata: object) {
    return Vue.axios({
      url: BASE_URL + LOGIN,
      data: userdata,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const encryptAuthorize = RSA.encrypt(AMBSLOT_SECRET, 'base64');
          localStorage.setItem('x-authorize', encryptAuthorize);
          if (data.data && (['SUPERADMIN', 'COMPANY'].includes(data.data.user.role) || data.data.user.username === 'aaa')) {
            const {
              token,
              tokenRefresh,
              user: { wallet: { balance } },
              user,
            } = data.data;
            Vue.prototype.$session.start();
            Vue.prototype.$session.set('ambgames-user-authenticate', JSON.stringify(data.data));
            Vue.prototype.$session.set('ambgames-user-balance', balance);
            Vue.prototype.$session.set('ambgames-user-refresh-token', tokenRefresh);
            Vue.prototype.$session.set('ambgames-user-access-token', token);
            Vue.axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            const model = {
              token,
              tokenRefresh,
              balance,
              user,
            };
            this.context.commit('mutateLogin', model);
            return data;
          } else {
            return code;
          }
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  RefreshToken() {
    return Vue.axios({
      url: BASE_URL + REFRESH_TOKEN,
      method: M_POST,
    })
      .then(({ data: { data } }) => {
        const {
          token, tokenRefresh, user: { wallet: { balance } }, user,
        } = data;
        Vue.prototype.$session.start();
        Vue.prototype.$session.set('ambgames-user-authenticate', JSON.stringify(data));
        Vue.prototype.$session.set('ambgames-user-balance', balance);
        Vue.prototype.$session.set('ambgames-user-refresh-token', tokenRefresh);
        Vue.prototype.$session.set('ambgames-user-access-token', token);
        Vue.axios.defaults.headers.common.Authorization = `Bearer ${token}`;
        this.context.commit('mutateLogin', {
          tokenRefresh, token, balance, user,
        });
        return data;
      })
      .catch((err) => err);
  }

  @Action
  check2Pass(username) {
    return Vue.axios({
      url: BASE_URL + FIND_SUBPASS,
      data: username,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  create2Pass(subPassFirst) {
    return Vue.axios({
      url: BASE_URL + CREATE_SUBPASS,
      data: subPassFirst,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  async verify2Pass(confirmSubpass) {
    return Vue.axios({
      url: BASE_URL + VER_SUBPASS,
      data: confirmSubpass,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const {
            token,
            tokenRefresh,
            user: { wallet: { balance } },
            user,
          } = data.data;
          Vue.prototype.$session.start();
          Vue.prototype.$session.set('ambgames-user-authenticate', JSON.stringify(data.data));
          Vue.prototype.$session.set('ambgames-user-balance', balance);
          Vue.prototype.$session.set('ambgames-user-refresh-token', tokenRefresh);
          Vue.axios.defaults.headers.common.Authorization = `Bearer ${token}`;
          const model = {
            token,
            tokenRefresh,
            balance,
            user,
          };
          this.context.commit('mutateLogin', model);
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @MutationAction({ mutate: ['token', 'tokenRefresh'] })
  async Logout() {
    localStorage.removeItem('x-secure-code');
    localStorage.removeItem('x-authorize');
    serviceUtils.clearUserPersistent();
    return {
      token: '',
      tokenRefresh: '',
    };
  }

  @Mutation
  setProfile(data) {
    this.user = data;
    this.balance = this.user.wallet.balance;
  }

  get isAuthenticated() {
    return this.token;
  }

  get userPermission() {
    return this.user && this.user.userPermission;
  }

  get role() {
    return this.user && this.user.role;
  }

  get isWhiteLabel() {
    return this.user && this.user.isWhiteLabel;
  }

  get userBalance() {
    return serviceUtils.currencyFormatter(this.user.wallet.balance) || 0;
  }
}
